import { Metamodel } from 'app/model/base/model';
import { IAttribute } from 'app/model/base/annotation';

import { BlobTypeStoreReadSettings } from './blob-type-store-read-settings';
import { FilePathMode } from 'app/registries/consts/metadata-consts';
import { StoreReadSettings } from './store-read-settings';
import { FtpServerLinkedService } from 'shell-models-lib';

@Metamodel.model({
    name: 'FtpReadSettings',
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(FtpServerLinkedService)
    }
})
export class FtpStoreReadSettings extends BlobTypeStoreReadSettings {
    // ftp store read settings doesn't have enablePartitionDiscovery, modifiedDatetimeStart/End
    public static readonly USE_BINARY_TRANSFER: IAttribute;
    public static readonly DISABLE_CHUNKING: IAttribute;

    public supportedFilePathMode = [
        FilePathMode.DATASET,
        FilePathMode.WILDCARD,
        FilePathMode.LIST
    ];

    @Metamodel.attribute({
        templatable: true,
        association: 'USE_BINARY_TRANSFER',
        display: stringResources.Ftp_Use_Binary_Transfer_Label
    })
    public useBinaryTransfer?: boolean = true;

    @Metamodel.attribute({
        display: stringResources.ModelName_DisableChunking,
        association: 'DISABLE_CHUNKING',
        templatable: true
    })
    public disableChunking?: boolean = false;

    public recoverPropFromPrevOne(prevStoreSettings: StoreReadSettings): void {
        super.recoverPropFromPrevOne(prevStoreSettings);
        this.updateModelValue('useBinaryTransfer', this, prevStoreSettings);
    }
}
